export function FormatName(given?: string, family?: string) : string | undefined {
  if (given !== undefined && family !== undefined) {
    return `${family.trim()}, ${given.trim()}`;
  }

  if (given !== undefined) {
    return given.trim();
  }
  
  if (family !== undefined) {
    return family.trim();
  }

  return undefined;
}